import { CbhIcon } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import { type PatientData, type VisitWithCaseData } from "../types";
import { VisitCardContentWrapper } from "./ContentWrapper";
import { VisitCardFooter } from "./Footer";
import { VisitCardSummaryInfo } from "./SummaryInfo";

interface VisitCardContentProps {
  visit: VisitWithCaseData;
  patient: PatientData | undefined;
  specialties: string[];
  workplaceName: string;
}

export function VisitCardContent(props: VisitCardContentProps) {
  const { visit, patient, specialties, workplaceName } = props;

  return (
    <VisitCardContentWrapper>
      <Stack spacing={5} direction="row" alignItems="flex-start">
        <Box
          sx={(theme) => ({
            display: "inline-flex",
            alignItems: "center",
            padding: 7,
            borderRadius: theme.borderRadius?.small,
            flexShrink: 0,
            background: theme.palette.homeHealth?.visit.gradient,
          })}
        >
          <CbhIcon type="house-filled" />
        </Box>
        <VisitCardSummaryInfo visit={visit} patient={patient} workplaceName={workplaceName} />
      </Stack>
      <VisitCardFooter visit={visit} specialties={specialties} />
    </VisitCardContentWrapper>
  );
}
